<div class="global-search" #globalSearch>
  <ng-container *ngIf="!isSearchFocused && !searchTerm">
    <button (click)="$event.stopPropagation(); onSearchClick()" (focusin)="onSearchClick()" aria-label="Search" ui-button uiShape="round">
      <i ui-icon uiType="search" data-test-id="global-search-icon"></i>
    </button>
  </ng-container>
  <ng-container *ngIf="!isSearchFocused && !!searchTerm">
    <div class="search-actions" (click)="$event.stopPropagation(); onSearchClick()" (focusin)="onSearchClick()">
      <i ui-icon uiType="search" data-test-id="global-search-icon"></i>
      <input class="search-input" id="search-input-readonly" [ngModel]="searchTerm" [uiBorderless]="true" [ngStyle]="{ width: '100px' }" ui-input />
    </div>
  </ng-container>
  <ng-container *ngIf="isSearchFocused">
    <div class="search-actions" [uiVisible]="shouldShowPopover" [uiContent]="resultTemplate" ui-popover uiOverlayClassName="without-arrow" uiPlacement="bottomRight" uiTrigger="click">
      <i ui-icon uiType="search" data-test-id="global-search-icon"></i>
      <input
        class="search-input"
        id="search-input"
        #searchInput
        [(ngModel)]="searchTerm"
        [uiBorderless]="true"
        [placeholder]="'search' | localize"
        (ngModelChange)="onSearchTermChange()"
        (keydown.arrowDown)="focusSearchItems()"
        (keydown.esc)="onEsc()"
        (focusout)="focusout($event)"
        ui-input
        role="searchbox"
        data-test-id="nav-bar-global-search-input" />
      <ui-divider uiType="vertical"></ui-divider>
      <span
        class="current-facet"
        id="facet-menu-button"
        #currentFacet
        [(uiVisible)]="isFacetMenuOpen"
        [attr.aria-expanded]="isFacetMenuOpen"
        [uiDropdownMenu]="menucl"
        (keydown)="openFacetDropdown($event)"
        (uiVisibleChange)="onFacetMenuOpen()"
        (focusout)="focusout($event)"
        role="combobox"
        aria-controls="menu"
        ui-dropdown
        uiTrigger="click"
        uiPlacement="bottomRight"
        tabindex="0"
        data-test-id="global-facet-dropdown">
        {{ currentFacet$ | async | localize }}
        <i ui-icon uiType="chevron-down-small"></i>
      </span>
      <ui-dropdown-menu #menucl="uiDropdownMenu">
        <ul class="facet-option-menu" #facetMenu style="min-width: 140px" ui-menu data-test-id="global-facet-dropdown-menu">
          <li
            *ngFor="let facet of facetOptions$ | async | filterFacetOptions : facetsToHide"
            [attr.aria-selected]="(currentFacet$ | async) === facet"
            (click)="changeFacet(facet)"
            (keydown.arrowDown)="moveFocusTo('next')"
            (keydown.arrowUp)="moveFocusTo('prev')"
            (keydown.enter)="changeFacet(facet)"
            (keydown.space)="changeFacet(facet)"
            (keydown.esc)="focusCurrentFacet()"
            role="option"
            tabindex="0">
            <span class="facet-option">{{ facet | localize }}</span>
          </li>
        </ul>
      </ui-dropdown-menu>
    </div>
    <ng-template #resultTemplate>
      <div class="results" #resultsPopover [ngStyle]="{ 'max-height.px': calculateMaxHeight(), 'overflow-y': 'auto' }">
        <ng-container *ngIf="!gettingSearchData">
          <search-results (keydown.esc)="onEsc()"></search-results>
          <no-search-items-found></no-search-items-found>
        </ng-container>
        <ng-container *ngIf="!!gettingSearchData">
          <div class="skeleton">
            <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 1 }"></ui-skeleton>
            <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 3 }"></ui-skeleton>
            <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 2 }"></ui-skeleton>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>
</div>
